export function sanitizeReturnUrl(candidate) {
	if (typeof candidate !== 'string') {
		return null;
	}

	const trimmedValue = candidate.trim();
	if (!trimmedValue.startsWith('/') || trimmedValue.startsWith('//')) {
		return null;
	}

	return trimmedValue;
}

export function getReturnUrlFromSearch(search = '') {
	try {
		const params = new URLSearchParams(search || '');
		return sanitizeReturnUrl(params.get('returnUrl'));
	} catch (error) {
		return null;
	}
}

export function resolvePostAuthReturnUrl(returnUrl, search = '') {
	return sanitizeReturnUrl(returnUrl) || getReturnUrlFromSearch(search) || '/';
}

export function shouldRedirectAfterAuth(targetUrl, pathname = '', search = '') {
	const currentPath = pathname || '/';
	const currentSearch = search || '';
	return targetUrl !== `${currentPath}${currentSearch}`;
}
